import { render, staticRenderFns } from "./UserEditDesignation.vue?vue&type=template&id=14afe9c9&"
import script from "./UserEditDesignation.vue?vue&type=script&lang=js&"
export * from "./UserEditDesignation.vue?vue&type=script&lang=js&"
import style0 from "./UserEditDesignation.vue?vue&type=style&index=0&id=14afe9c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports